import { styled } from 'styled-components';
export const FileStatusCard = styled.div `
  padding: 8px 16px;
  width: 100%;
`;
export const FileAttributes = styled.div `
  display: flex;
  flex-flow: row nowrap;
  gap: 4px;
  align-items: flex-start;
`;
export const FileActions = styled.div `
  display: flex;
  flex-flow: row nowrap;
  gap: 4px;
  align-items: center;
`;
export const FileName = styled.div `
  margin-right: auto;
  overflow: hidden;
  word-wrap: break-word;
`;
export const ProgressBarAppearance = styled.div `
  background-color: ${({ theme }) => theme.colors.grey30_1};
  height: 2px;
  width: 100%;
  margin-top: 4px;
  position: relative;
  & > div {
    background-color: ${({ theme, customColor }) => customColor ?? theme.colors.main};
    border-radius: 2px;
    height: 100%;
    position: absolute;
    content: '';
  }
`;
